// frontend/src/StoreLocator/DateField.jsx — a Polaris date field: a text field with a calendar button that opens a DatePicker.
// Value is "YYYY-MM-DD" or "".
import React, { useCallback, useState } from 'react';
import { BlockStack, Box, Button, DatePicker, InlineStack, Popover, TextField } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';

const toYmd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const fromYmd = (s) => (s && /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T12:00:00`) : null);
const pretty = (s) => { const d = fromYmd(s); return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''; };

export default function DateField({ label, value, onChange, min }) {
  const [open, setOpen] = useState(false);
  const base = fromYmd(value) || fromYmd(min) || new Date();
  const [view, setView] = useState({ month: base.getMonth(), year: base.getFullYear() });
  const selected = fromYmd(value);
  const pick = useCallback(({ start }) => { onChange(toYmd(start)); setOpen(false); }, [onChange]);
  const activator = (
    <TextField label={label} value={pretty(value)} placeholder="Pick a date" autoComplete="off" readOnly onFocus={() => setOpen(true)}
      prefix={<span className="uh-sl-cal" aria-hidden="true"><CalendarIcon /></span>} onChange={() => {}} />
  );
  return (
    <Popover active={open} activator={<div onClick={() => setOpen(true)} role="presentation">{activator}</div>} onClose={() => setOpen(false)} preferredAlignment="left">
      <Box padding="300" width="280px">
        <BlockStack gap="200">
          <div className="uh-sl-dp"><DatePicker month={view.month} year={view.year} onChange={pick} onMonthChange={(month, year) => setView({ month, year })} selected={selected || undefined} disableDatesBefore={fromYmd(min) || undefined} /></div>
          <InlineStack gap="200">
            <Button size="slim" onClick={() => { const t = new Date(); setView({ month: t.getMonth(), year: t.getFullYear() }); pick({ start: t }); }}>Today</Button>
            <Button size="slim" variant="tertiary" onClick={() => { onChange(''); setOpen(false); }}>Clear</Button>
          </InlineStack>
        </BlockStack>
      </Box>
    </Popover>
  );
}
